import React from "react"

export const ProgramHeader = () => {
  return (
    <tr>
      <td style={{ width: "180px" }}><b>Godzina rozpoczęcia</b></td>
      <td style={{ width: "100px" }}><b>Link</b></td>
      <td style={{ width: "105px" }}></td>
      <td style={{ width: "220px" }}><b>Wydarzenie</b></td>
      <td><b>Gość spotkania</b></td>
      <td></td>
    </tr>
  )
}
